import { render, staticRenderFns } from "./AggregatorCreate.vue?vue&type=template&id=658305e4&"
import script from "./AggregatorCreate.vue?vue&type=script&lang=js&"
export * from "./AggregatorCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports